(function () {
    'use strict';
  
    angular.module('bossApp.adobe', [])
    .factory('adobeAnalyticsService', adobeAnalyticsService);
  
    adobeAnalyticsService.$inject = ['$log'];
  
    function adobeAnalyticsService($log) {

        return {
            viewTracking: viewTracking
        };

        function viewTracking(data) {
          
            var object = {
                eventSent: 'link',
                interactionType: data.interactionType,
                interactionLabel: data.interactionLabel,
                interactionLocation: data.interactionLocation,
                extraInfo: data.extraInfo
            }
            try {
              digitalTrack(object);
              $log.log('digitalTrack', object);
            } catch(e) {
              $log.log('digitalTrack-error');
            }
        };
    }
  
})(window.angular);  